import React from 'react';
import { DEFAULT_THEME } from "../themes/DefaultTheme";
export var ThemeContext = /*#__PURE__*/React.createContext(DEFAULT_THEME);
ThemeContext.displayName = 'ThemeContext';